import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  const quotes = ['No sé por dónde empezar.', 'No tengo tiempo.', 'No quiero meterme en algo complicado.', 'No soy experta en tecnología.', 'No quiero invertir en algo que después no entienda ni sepa aplicar.'];
  return <section className="py-20 md:py-32 bg-cream" data-id="element-214">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-215">
        {/* Part 1: The Situation */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="mb-20" data-id="element-216">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl lg:text-5xl font-bold text-navy mb-8 leading-tight text-center md:text-left" data-id="element-217">
            ¿Sientes que trabajas demasiado… y aun así no avanzas como
            quisieras?
          </motion.h2>

          <div className="space-y-6 text-lg text-slate-700 leading-relaxed" data-id="element-218">
            <motion.p variants={itemVariants} data-id="element-219">
              Te levantas temprano. Cumples horarios. Corres todo el día.
              Repites la misma rutina. Y al final del mes, el dinero apenas
              alcanza.
            </motion.p>
            <motion.p variants={itemVariants} data-id="element-220">
              Sabes que quieres algo más. Una nueva oportunidad. Una forma de
              generar ingresos sin depender únicamente de un trabajo agotador.
            </motion.p>
            <motion.p variants={itemVariants} data-id="element-221">
              Pero cada vez que piensas en emprender, aparece la misma
              sensación:
            </motion.p>
          </div>

          {/* Quotes */}
          <motion.div variants={containerVariants} className="my-10 grid gap-4 md:grid-cols-2" data-id="element-222">
            {quotes.map((quote, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-gold relative overflow-hidden group" data-id="element-223">
                <div className="absolute top-0 right-0 w-16 h-16 bg-gold/5 rounded-bl-full -mr-8 -mt-8 transition-transform group-hover:scale-150" data-id="element-224"></div>
                <p className="text-navy font-medium italic relative z-10" data-id="element-225">
                  "{quote}"
                </p>
              </motion.div>)}
          </motion.div>

          <div className="space-y-6 text-lg text-slate-700 leading-relaxed" data-id="element-226">
            <motion.p variants={itemVariants} data-id="element-227">
              Y así, pasan los días, las semanas, los meses… y sigues sintiendo
              que cambias tu tiempo por un ingreso que no te da la libertad que
              deseas.
            </motion.p>
            <motion.p variants={itemVariants} data-id="element-228">
              La parte más frustrante no es solo el cansancio. Es sentir que
              podrías estar construyendo algo tuyo… pero no sabes cómo empezar
              de una forma simple, realista y posible para ti.
            </motion.p>
          </div>
        </motion.div>

        {/* Part 2: The Shift */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="bg-white rounded-2xl p-8 md:p-12 shadow-lg border border-slate-100" data-id="element-229">
          <motion.h3 variants={itemVariants} className="text-2xl md:text-3xl font-bold text-navy mb-6" data-id="element-230">
            No es que no puedas.
            <br data-id="element-231" />
            <span className="text-gold" data-id="element-232">
              Es que te mostraron caminos demasiado complicados.
            </span>
          </motion.h3>

          <div className="space-y-6 text-lg text-slate-700 leading-relaxed" data-id="element-233">
            <motion.p variants={itemVariants} data-id="element-234">
              Tal vez ya intentaste buscar opciones.
            </motion.p>
            <motion.p variants={itemVariants} data-id="element-235">
              Probaste ideas que parecían buenas, pero eran enredadas. Viste
              cursos llenos de teoría, pero vacíos de aplicación real. Te
              hablaron de negocios digitales como si necesitaras experiencia
              previa, herramientas complejas, horas libres de sobra o una
              inversión grande para comenzar.
            </motion.p>
            <motion.p variants={itemVariants} data-id="element-236">
              Y ahí fue donde te frenaste.
            </motion.p>
            <motion.p variants={itemVariants} data-id="element-237">
              No porque no seas capaz. No porque no tengas potencial. No porque
              no puedas aprender.
            </motion.p>
            <motion.p variants={itemVariants} className="font-medium text-navy" data-id="element-238">
              Sino porque te hicieron creer que emprender tenía que sentirse
              difícil, técnico y abrumador desde el primer día.
            </motion.p>
            <motion.div variants={itemVariants} className="pt-6 mt-6 border-t border-slate-100" data-id="element-239">
              <p className="text-xl md:text-2xl font-serif font-bold text-navy" data-id="element-240">
                Pero hoy eso ya no tiene por qué ser así.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}